<template>
  <div class="chat-body">
    <div class="search-wrap">
      <!-- <el-select v-model="projectId" filterable placeholder="选择项目" clearable>
        <el-option v-for="item in projectList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <el-date-picker size="mini" v-model="dateSpan" type="daterange" align="right" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
      </el-date-picker>
      <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
    </div>

    <div class="table-wrap-c">
      <el-table :height="__TABLE_HEIGHT__" v-loading="loading" default-expand-all class="chat-table" :data="tableData" row-key="index">
        <el-table-column type="index" label="排名" align="center"></el-table-column>
        <el-table-column prop="project_name" label="项目" align="center"></el-table-column>
        <el-table-column prop="group_name" label="群" align="center"></el-table-column>
        <el-table-column prop="category" label="方向" width="250" align="center"></el-table-column>
        <el-table-column prop="keyword" label="关键词" width="150" align="center"></el-table-column>
        <el-table-column prop="count" label="频次" align="center"></el-table-column>
        <el-table-column prop="member_count" label="人数" align="center"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button class="text2" type="primary" size="mini" round icon="el-icon-view" @click="detail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>

export default {
  name: "ConversationGroupCrisis",
  data () {
    return {
      dateSpan: [],
      tableData: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      loading: false,
    }
  },
  created() {
    //this.getProjectList()
  },
  watch: {
    projectId() {
      this.ChatId = ''
    }
  },
  computed:{
    __TABLE_HEIGHT__(){
      return (window.outerHeight - 300) + 'px'
    }
  },
  methods: {
    search() {
      this.getData()
    },
    getData() {
      this.loading = true
      this.$qwhttp.get('group/crisis_ranking', {params: this.getParams()}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.tableData = []
          if(res.data.data != null) {
            this.tableData = res.data.data
          }
        }
        this.loading = false
      })
    },

    getParams() {
      return {
        start_date: this.dateSpan.length ? this.dateSpan[0] : '',
        end_date: this.dateSpan.length ? this.dateSpan[1] : ''
      }
    },

    detail(row) {
      this.$router.push({path: '/Conversation/Chat',
        query:{
          'start_date': this.dateSpan.length ? this.dateSpan[0] + ' 00:00:00' : '',
          'end_date': this.dateSpan.length ? this.dateSpan[1] + ' 23:59:59' : '',
          'room_id': row.room_id,
          'keyword': row.keyword
        }
      });
    }

  }
}
</script>
<style scoped lang="scss">
  .text2,.el-button--primary {
    color: #FFFFFF;
  }
  .add-type {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
  }
  .search-wrap {
    padding-bottom: 15px;
    border-bottom: 1px solid #EBEEF5;
    display: flex;
    align-items: center;

    > * {
      margin-right: 5px;
    }
  }
  .chat-body {
    position: relative;
    padding: 15px;
  }
  .pagination {
    display: flex;
    padding: 15px 0;
    justify-content: center;
  }
  .tag-department {
    margin: 1px 1px 1px 0;
    height: auto;
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/GroupCrisis.vue